{#if widget === 'vertical'}
  <WidgetVertical on:load="callback(event)"/>
{:elseif widget === 'horizontal'}
  <WidgetHorizontal on:load="callback(event)"/>
{/if}

<style type="text/scss">
  @import './style/main.scss';
</style>

<script>
  import WidgetVertical from './components/widget-vertical.html';
  import WidgetHorizontal from './components/widget-horizontal.html';

  import getParams from './util/get-params';

  export default {
    data () {
      return {
        widget: null
      };
    },
    oncreate () {
      const params = getParams(window && window.location ? window.location.href || '' : '');
      this.set({ widget: params.page && params.page === 'game' ? 'vertical' : 'horizontal' });
    },
    methods: {
      callback (element) {
        let dimensions = {
          width: element.offsetWidth,
          height: element.offsetHeight
        };
        const data = { dimensions };
        // if (window && window.top) window.top.postMessage(JSON.stringify(data), '*');
        if (window && window.top) window.top.postMessage(data, '*');
      }
    },
    components: {
      WidgetVertical,
      WidgetHorizontal
    }
  };
</script>
